import { useQuery } from "convex/react"
import { useCallback } from "react"
import { Link, useParams } from "react-router-dom"
import { FeedList } from "@/components/app/FeedList"
import { UserPageSkeleton } from "@/components/app/Skeletons"
import { UserProfileHeader } from "@/components/app/UserProfileHeader"
import { useAppAuth } from "@/hooks/useAppAuth"
import { useUserPostsByHandle } from "@/hooks/useUserPostsPaginated"
import { api } from "~convex/_generated/api"

export default function UserPage() {
	const { isAuthenticated } = useAppAuth()
	const { handle } = useParams<{ handle: string }>()
	const profile = useQuery(
		api.users.getUserByHandle,
		isAuthenticated && handle ? { handle } : "skip",
	)
	const posts = useUserPostsByHandle(handle ?? null, isAuthenticated && !!handle)
	const handleLoadMore = useCallback(() => posts.loadMore(20), [posts])

	if (profile === undefined) {
		return <UserPageSkeleton />
	}

	if (profile === null) {
		return (
			<div className="py-12 text-center">
				<p className="text-app-text-secondary">User not found</p>
				<Link className="mt-2 inline-block text-neon text-sm hover:underline" to="/">
					Back to home
				</Link>
			</div>
		)
	}

	return (
		<div>
			<UserProfileHeader
				avatarUrl={profile.avatar_url}
				bio={profile.bio}
				displayName={profile.display_name}
				followerCount={profile.follower_count}
				followingCount={profile.following_count}
				followsYou={profile.followsYou}
				handle={profile.handle}
				isFollowedByMe={profile.isFollowedByMe ?? undefined}
				isMirrored={profile.isMirrored}
				postCount={profile.post_count ?? 0}
				twitterUsername={profile.twitter_username}
				userId={profile._id}
				walletAddress={profile.wallet_address}
			/>

			<FeedList
				hasMore={posts.status === "CanLoadMore"}
				isLoading={posts.status === "LoadingFirstPage" || posts.status === "LoadingMore"}
				loadMore={handleLoadMore}
				posts={posts.results}
			/>
		</div>
	)
}
